import { cpp } from "@codemirror/lang-cpp";
import { java } from "@codemirror/lang-java";
import { python } from "@codemirror/lang-python";
import { javascript } from "@codemirror/lang-javascript";

export const getCodeMirrorExtensions = (lang) => {
  switch (lang) {
    case "cpp":
    case "c":
      return [cpp()];
    case "java":
      return [java()];
    case "python":
      return [python()];
    case "scala":
      return [java()];
    case "react":
      return [javascript({ jsx: true })]; // JavaScript with JSX support
    case "javascript":
    case "js":
      return [javascript()]; // Pure JavaScript
    case "angular":
      return [javascript({ typescript: true })]; // TypeScript support
    default:
      return [];
  }
};
